import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


export const fetchBrands = createAsyncThunk("brands/fetchBrands", async () => {
  try {
    const response = await axios.get("http://192.168.0.127:8000/api/brands");
console.log("data",response.data);

    return response.data.brands ;
  } catch (error) {

    throw error; 
  }
});

const brandSlice = createSlice({
  name: "brands",
  initialState: {
    brands: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBrands.pending, (state) => {
        state.loading = true;
        state.error = null; 
      })
      .addCase(fetchBrands.fulfilled, (state, action) => {
        state.loading = false;
        state.brands = action.payload;
     
      })
      .addCase(fetchBrands.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;

      });
  },
});

export default brandSlice.reducer;
